<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <!-- 工事日報タイトル -->
          <v-card-title>
            工事日報
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field class="mt-3" label="作業日" v-model="constructionDate" prepend-inner-icon="mdi-calendar-month" dense outlined readonly/>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field class="mt-3" label="工番" v-model="constructionNumber" prepend-inner-icon="mdi-newspaper-variant-outline" dense outlined readonly/>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field class="mt-3" label="現場名" v-model="constructionName" prepend-inner-icon="mdi-crane" dense outlined readonly/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4" class="ml-5">
                <v-data-table :headers="reportTotalHeaders" :items="reportTotalDataTable" show-expand item-key="name" :expanded.sync="expanded" hide-default-header hide-default-footer>
                  <template slot="top">
                    <v-toolbar color="accent" dark flat dense>
                        <v-toolbar-title>日報総計</v-toolbar-title>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.data-table-expand`]="{ item, isExpanded, expand }">
                    <v-btn icon text @click="expand(true)" v-if="item.canExpand && !isExpanded"><v-icon>mdi-chevron-down</v-icon></v-btn>
                    <v-btn icon text @click="expand(false)" v-if="item.canExpand && isExpanded"><v-icon>mdi-chevron-up</v-icon></v-btn>
                  </template>
                  <template v-slot:expanded-item="{ headers }">
                    <td :colspan="headers.length">
                      <v-data-table dense :headers="headers" :items="reportAggregateDataTable" :items-per-page="itemPerPage" hide-default-header hide-default-footer>
                        <template v-slot:no-data>データがありません</template>
                      </v-data-table>
                    </td>
                  </template>
                  <template v-slot:no-data>データがありません</template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- タブヘッダー -->
          <v-tabs v-model="selectTab" background-color="accent" dark show-arrows next-icon="mdi-arrow-right-bold-box-outline" prev-icon="mdi-arrow-left-bold-box-outline">
            <v-tab v-for="index in tabLength" :key="index" :href="'#tab-'+index">{{ "工種：" + tabDataList['tab-'+index].tabName }}</v-tab>
            <v-tabs-slider color="red"/>
          </v-tabs>
          <!-- タブボディ -->
          <v-tabs-items v-model="selectTab">
            <v-tab-item v-for="index in tabLength" :key="index" :value="'tab-'+index">
              <v-container fluid>
                <!-- 作業報告 -->
                <v-row>
                  <v-col cols="12">
                    <v-data-table :headers="workHeaders" :items="tabDataList['tab-' + index].workDataTable" :items-per-page="itemPerPage" hide-default-footer>
                      <template slot="top">
                        <v-toolbar color="accent" dark flat dense>
                            <v-toolbar-title>作業報告</v-toolbar-title>
                        </v-toolbar>
                      </template>
                      <template v-slot:[`item.work`]="{ item }">
                        <v-btn class="my-2" depressed small color="info" @click.stop="showWorkerContentReferenceDialog(item)">作業内容参照</v-btn>
                      </template>
                      <template v-slot:no-data>データがありません</template>
                    </v-data-table>
                    <v-divider></v-divider>
                    <v-data-table :headers="achievementWorkHeaders" :items="tabDataList['tab-' + index].employmentCostDataTable" :items-per-page="itemPerPage" hide-default-footer>
                      <template slot="top">
                        <v-toolbar color="grey" dark flat dense>
                            <v-toolbar-title>{{ workIndexName }}</v-toolbar-title>
                        </v-toolbar>
                      </template>
                      <template v-slot:no-data>データがありません</template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <!-- 経費区分 -->
                <v-row>
                  <v-col cols="12">
                    <v-toolbar color="accent" dark flat dense>
                      <v-toolbar-title>経費区分</v-toolbar-title>
                    </v-toolbar>
                    <div v-for="(data, name) in tabDataList['tab-' + index].expenseTableData" :key="name">
                      <v-row class="mt-2">
                        <v-col cols="12">
                          <v-data-table :headers="expenseHeaders" :items="data" :items-per-page="itemPerPage" hide-default-footer :key="renderingKeyCount">
                            <template slot="top">
                              <v-toolbar color="grey" dark flat dense>
                                  <v-toolbar-title>{{ name }}</v-toolbar-title>
                                  <v-spacer/>
                                  <v-btn depressed color="success" @click="createItem(name)">新規作成</v-btn>
                              </v-toolbar>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                              <v-btn class="mr-2" depressed color="primary" @click="editItem(item)">入力</v-btn>
                              <v-btn class="mr-2" depressed color="error" @click="deleteItem(item)">削除</v-btn>
                            </template>
                            <template v-slot:no-data>データがありません</template>
                          </v-data-table>
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-data-table :headers="totalHeaders" :items="tabDataList['tab-' + index].totalDataTable" :items-per-page="itemPerPage" hide-default-header hide-default-footer>
                      <template slot="top">
                        <v-toolbar color="accent" dark flat dense>
                            <v-toolbar-title>総計</v-toolbar-title>
                        </v-toolbar>
                      </template>
                      <template v-slot:no-data>データがありません</template>
                    </v-data-table>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs-items>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" :to="{ name: 'ConstructionDailyReport', params: { number: this.constructionNumber } }">キャンセル</v-btn>
            <v-btn depressed color="primary" @click.prevent="comformDialog=!comformDialog" :disabled="confirmDisabled || tabLength === 0">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <!-- 確認ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="comformDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            工事日報登録
          </v-card-title>
          <v-card-text>
            <h4>工事日報を登録しますか？</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="comformDialog=!comformDialog">キャンセル</v-btn>
            <v-btn depressed color="success" @click.prevent="submit">登録</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 費目入力ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="expenseInputDialog" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">費目入力</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-select v-if="expenseItems.length > 0 && !editFlg" v-model="expenseItem" label="費目選択" :items="expenseItems" item-text="expense" @change="expenseChange" no-data-text="データがありません" dense outlined return-object/>
              <v-divider v-if="expenseItems.length > 0 && !editFlg" class="mb-5"/>
              <v-form ref="expense_input_form" v-model="expenseInputValid" @submit.prevent>
                <v-text-field v-model="expense" :rules="expenseNameRules" label="費目名" dense outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-text-field>
                <v-text-field v-model="standard" :rules="standardNameRules" label="規格等" dense outlined></v-text-field>
                <v-text-field v-model="achievement" :rules="amountRules" label="数量" dense outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-text-field>
                <v-text-field v-model="displayUnit" :rules="displayUnitRules" label="単位" dense outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-text-field>
                <v-text-field v-model="unitPrice" :rules="unitPriceRules" :label="price_updated" dense outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-text-field>
                <v-row no-gutters>
                  <v-col cols="11">
                    <v-autocomplete label="取引先" v-model="supplier" :items="suppliers" item-text="name" item-value="value" hide-no-data hide-selected outlined dense return-object/>
                  </v-col>
                  <v-col cols="1">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon class="mt-2 ml-3" color="success" @click.stop="supplierStoreDialogHandler" v-on="on">mdi-plus-circle</v-icon>
                      </template>
                      <span>取引先登録</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-text-field v-model="remarks" label="備考" :rules="remarksRules" dense outlined required></v-text-field>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" @click.stop="expenseInputCancelHandler">キャンセル</v-btn>
            <v-btn color="success" @click.stop="expenseInputSaveHandler" :disabled="!expenseInputValid">保存</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 費目編集ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="expenseEditDialog" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">費目編集</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="expense_edit_form" v-model="expenseEditValid" @submit.prevent>
                <v-text-field v-model="expense" :rules="expenseNameRules" label="費目名" dense outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-text-field>
                <v-text-field v-model="standard" :rules="standardNameRules" label="規格等" dense outlined></v-text-field>
                <v-text-field v-model="achievement" :rules="amountRules" label="数量" dense outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-text-field>
                <v-text-field v-model="displayUnit" :rules="displayUnitRules" label="単位" dense outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-text-field>
                <v-text-field v-model="unitPrice" :rules="unitPriceRules" :label="price_updated" dense outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-text-field>
                <v-row no-gutters>
                  <v-col cols="11">
                    <v-autocomplete label="取引先" v-model="supplier" :items="suppliers" item-text="name" item-value="value" hide-no-data hide-selected outlined dense return-object/>
                  </v-col>
                  <v-col cols="1">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon class="mt-2 ml-3" color="success" @click.stop="supplierStoreDialogHandler" v-on="on">mdi-plus-circle</v-icon>
                      </template>
                      <span>取引先登録</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-text-field v-model="remarks" label="備考" :rules="remarksRules" dense outlined required></v-text-field>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" @click.stop="expenseEditCancelHandler">キャンセル</v-btn>
            <v-btn color="warning" @click.stop="expenseEditSaveHandler" :disabled="!expenseEditValid">更新</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 取引先登録ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="supplierStoreDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            <span>取引先登録</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="suppliers_form" v-model="supplierValid" @submit.prevent>
              <v-text-field label="取引先名" v-model="supplierName" :rules="suppliersNameRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="備考" v-model="supplierRemarks" :rules="remarksRules" dense outlined></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="supplierStoreDialogCancelHandler">キャンセル</v-btn>
            <v-btn color="success" @click.prevent="supplierStore" :disabled="!supplierValid" depressed>登録</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 費目削除ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="expenseDeleteDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            費目削除
          </v-card-title>
          <v-card-text>
            <h4>{{ editedItem.expense }} を削除しますか？</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="expenseDeleteDialog = !expenseDeleteDialog">キャンセル</v-btn>
            <v-btn depressed color="error" @click.stop="expenseDeleteHandler">削除</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="workerContentReferenceDialogDrawer" persistent max-width="700">
        <v-card>
          <v-card-title class="headline">作業内容参照</v-card-title>
          <v-card-text v-if="tabLength > 0">
            <v-toolbar color="accent" dark flat dense><v-toolbar-title>{{ constructionName }}</v-toolbar-title></v-toolbar>
            <v-row>
              <v-col cols="2"><header>作業者</header></v-col>
              <v-col cols="10"><header>{{ this.workItem.worker }}</header></v-col>
            </v-row>
            <v-divider/>
            <v-row>
              <v-col cols="2"><header>作業内容</header></v-col>
              <v-col cols="10"><header style="white-space:pre-wrap; word-wrap:break-word;">{{ this.workItem.work }}</header></v-col>
            </v-row>
            <v-divider/>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="workerContentReferenceDialogDrawer = false">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 費目登録時警告ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="expenseAlertDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            <span><v-icon large class="mr-2" color="red">mdi-alert-octagon</v-icon>実行できません</span>
          </v-card-title>
          <v-card-text>
            選択された費目は既に登録されています。
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="expenseAlertDialog=!expenseAlertDialog">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import Rule from "@/validation/rules";
import SuppliersApi from "@/api/suppliers-api";
import ConstructionAggregateApi from "@/api/construction-aggregate-api";
import ConstructionDailyReportApi from "@/api/construction-daily-report-api";
import CalcCommon from "@/helpers/calcCommon";

export default {
  name: "ConstructionDailyReportStore",
  data: () => ({
    // ------------------------
    // 共通
    // ------------------------
    renderingKeyCount: 0,
    loading: false,
    // 作業日
    constructionDate: "",
    // 工番ID
    constructionID: "",
    // 工番名
    constructionNumber: "",
    // 現場名
    constructionName: "",
    // データ表示数
    itemPerPage: 300,

    // ------------------------
    // タブ
    // ------------------------
    tabLength: 0,
    selectTab: null,

    tabData: {
      tabName: null,
      constructionType: null,
      workDataTable: [],
      employmentCostDataTable: [],
      expenseTableData: [],
      totalDataTable: [],
      expenseSelectBox: []
    },
    // 本データ用
    tabDataList: {},
    confirmDisabled: false,

    // ------------------------
    // 日報総計
    // ------------------------
    workIndexName: "作業実績",
    totalIndexName: "総計",
    todayIndexName: "当計",
    budgetTotalIndexName: "予算累計",
    achievementTotalIndexName: "実績累計",
    reportTotalHeaders: [
      { text: "名称", value: "name" },
      { text: "計", value: "total", align: "end" },
      { text: '', value: 'data-table-expand' }
    ],
    reportTotalDataTable: [],
    reportAggregateDataTable: [],
    expanded: [],

    // ------------------------
    // 作業報告
    // ------------------------
    workHeaders: [
      { text: "作業者", value: "worker" },
      { text: "作業時間", value: "workerTime" },
      { text: "作業時間(休憩)", value: "breakWorkerTime" },
      { text: "実績作業時間", value: "achievementWorkerTime" },
      { text: "残業時間", value: "overTime" },
      { text: "残業時間(休憩)", value: "breakOverTime" },
      { text: "実績残業時間", value: "achievementOverTime" },
      { text: "作業内容", value: "work" }
    ],
    achievementWorkHeaders: [
      { text: "作業名", value: "workName" },
      { text: "実績作業時間", value: "totalTime" },
      { text: "単価(時)", value: "unitPrice", align: 'end' },
      { text: "金額(税抜)", value: "workPrice", align: 'end' }
    ],
    // ------------------------
    // 経費区分
    // ------------------------
    expenseHeaders: [
      { text: "費目名", value: "expense" },
      { text: "規格等", value: "standard" },
      { text: "実績 / 予算", value: "displayAchievement" },
      { text: "単位", value: "displayUnit" },
      { text: "単価", value: "unitPrice", align: 'end' },
      { text: "金額(税抜)", value: "price", align: 'end' },
      { text: "取引先", value: "supplierName" },
      { text: "アクション", value: "action" }
    ],
    editedIndex: -1,
    editedItem: {},
    expenseId: "",
    expense: "",
    standard: "",
    amount: "",
    achievement: "",
    displayUnit: "",
    unitPrice: "",
    remarks: "",
    priceUpdated: "",
    before_price: null,
    price_updated: "単価",
    suppliers: [],
    supplier: null,
    expenseDivisionData: [],
    expenseSelectBox: [],
    expenseItems: [],
    expenseItem: null,

    // ------------------------
    // 総計
    // ------------------------
    totalHeaders: [
      { text: "費目名", value: "expense", align: 'end' },
      { text: "金額(税抜)", value: "price", align: "end" }
    ],

    // 確認ダイアログ
    comformDialog: false,

    // 費目入力ダイアログ
    expenseInputDialog: false,
    expenseInputValid: false,
    expenseChangeFlg: false,
    expenseNameRules: Rule.expenseNameRules,
    standardNameRules: Rule.standardNameRules,
    amountRules: Rule.amountRules,
    displayUnitRules: Rule.displayUnitRules,
    unitPriceRules: Rule.unitPriceRules,
    remarksRules: Rule.remarksRules,

    // 費目編集ダイアログ
    expenseEditDialog: false,
    expenseEditValid: false,
    editFlg: false,

    // 取引先登録ダイアログ
    supplierStoreDialog: false,
    supplierName: "",
    supplierRemarks: "",
    supplierValid: false,
    suppliersNameRules: Rule.suppliersNameRules,

    // 費目削除ダイアログ
    expenseDeleteDialog: false,

    // ------------------------
    // 作業内容参照ダイアログ
    // ------------------------
    workItem: {},
    workerContentReferenceDialogDrawer: false,

    // ------------------------
    // 費目登録時警告ダイアログ
    // ------------------------
      expenseAlertDialog: false,
  }),
  created () {
    this.initialize();
  },
  watch: {
    achievement (value) {
      this.achievement = this.stringFormat(value);
    },
    unitPrice (value) {
      if (this.before_price != null && this.before_price != value) {
        this.priceUpdated = this.getNowYMD();
        this.price_updated = "単価 (更新日時: " + this.priceUpdated + ")";
      }
      this.unitPrice = this.stringFormat(value);
    }
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    initialize () {
      this.isLoading();
      this.constructionDate = this.$route.params.date;
      this.constructionID = this.$route.params.id;
      this.constructionNumber = this.$route.params.number;
      this.constructionName = this.$route.params.name;

      this.suppliersApi = new SuppliersApi();
      this.constructionDailyReportApi = new ConstructionDailyReportApi();
      this.constructionAggregateApi = new ConstructionAggregateApi();
      const promise = this.constructionAggregateApi.info(this.constructionDate, this.constructionID);
      promise.then((response) => {

        // 取引先リスト
        for (var supplier of response.data.body.suppliers_list) {
          this.suppliers.push({
            name: supplier.name,
            value: supplier.id
          });
        }
        // 経費区分リスト
        for (var agregateName in response.data.body.aggregate_list ) {
          var agregate = response.data.body.aggregate_list[agregateName];
          this.expenseDivisionData[agregateName] = agregate;
        }

        var construction_report_list = {};
        for (var item of response.data.body.construction_aggregate_info) {
          // 工種ノード
          var node = item.report.constructionType.value + ":" + item.report.constructionType.name;
          if (!construction_report_list[node]) {
            construction_report_list[node] = {
              tabName: null,
              constructionType: null,
              employmentCostDataTable: [],
              workDataTable: [],
              expenseTableData: {},
              expenseSelectBox: []
            };
            construction_report_list[node].tabName = item.report.constructionType.name;
            construction_report_list[node].constructionType = item.report.constructionType;
            construction_report_list[node].expenseSelectBox = item.report.expenseSelectBoxList[item.report.constructionType.value];
          }
          // 作業報告
          var workerTime = null;
          var breakWorkerTime = null;
          var achievementWorkerTime = null;
          if (item.report.startWorkerTime != null && item.report.endWorkerTime != null) {
            workerTime = item.report.startWorkerTime + "〜" + item.report.endWorkerTime;
            var workerBreakHourTime = item.report.workerBreakHourTime == null ? "0" : String(item.report.workerBreakHourTime);
            var workerBreakMinuteTime = item.report.workerBreakMinuteTime == null ? "0" : String(item.report.workerBreakMinuteTime);
            breakWorkerTime = workerBreakHourTime + "時間" + workerBreakMinuteTime + "分";
            achievementWorkerTime = String(item.report.workerTime.hour) + "時間" + String(item.report.workerTime.minute) + "分";
          }
          var overTime = null;
          var breakOverTime = null;
          var achievementOverTime = null;
          if (item.report.startOverTime != null && item.report.endOverTime != null) {
            overTime = item.report.startOverTime + "〜" + item.report.endOverTime;
            var overBreakHourTime = item.report.overBreakHourTime == null ? "0" : String(item.report.overBreakHourTime);
            var overBreakMinuteTime = item.report.overBreakMinuteTime == null ? "0" : String(item.report.overBreakMinuteTime);
            breakOverTime = overBreakHourTime + "時間" + overBreakMinuteTime + "分";
            achievementOverTime = String(item.report.overTime.hour) + "時間" + String(item.report.overTime.minute) + "分";
          }
          construction_report_list[node].workDataTable.push({
            worker: item.user_name,
            workerTime: workerTime,
            breakWorkerTime: breakWorkerTime,
            achievementWorkerTime: achievementWorkerTime,
            overTime: overTime,
            breakOverTime: breakOverTime,
            achievementOverTime: achievementOverTime,
            work: item.report.workerContent
          });
          var workName = null;
          var aggregate = null;
          if (item.report.workItem != null) {
            workName = item.report.workItem.name;
            aggregate = item.report.workItem.value.aggregate;
          }
          var totalTime = 0;
          if (item.report.workerTime != null) {
            totalTime = totalTime + item.report.workerTime.hour;
          }
          if (item.report.overTime != null) {
            totalTime = totalTime + item.report.overTime.hour;
          }
          var workPrice = 0;
          if (item.hourly_pay != null) {
            workPrice = Math.round(totalTime * item.hourly_pay);
          }
          construction_report_list[node].employmentCostDataTable.push({
            workName: workName,
            unitPrice: CalcCommon.addFigure(item.hourly_pay),
            totalTime: String(totalTime) + "時間",
            workPrice: CalcCommon.addFigure(workPrice),
            aggregate: aggregate
          });
          // 経費区分
          for (var expense in item.report.expenseTableData) {
            if (!construction_report_list[node].expenseTableData[expense]) {
              construction_report_list[node].expenseTableData[expense] = [];
            }
            for (var ob of item.report.expenseTableData[expense]) {
              ob.price = CalcCommon.addFigure(ob.price);
              ob.unitPrice = CalcCommon.addFigure(ob.unitPrice);
              construction_report_list[node].expenseTableData[expense].push(ob);
            }
          }
        }
        // 本データ
        for (var report_index in construction_report_list) {
          this.tabLength++;
          this.selectTab = 'tab-'+this.tabLength;
          this.tabDataList[this.selectTab] = Object.assign({}, this.tabData);
          this.tabDataList[this.selectTab].tabName = construction_report_list[report_index].tabName;
          this.tabDataList[this.selectTab].constructionType = construction_report_list[report_index].constructionType;
          this.tabDataList[this.selectTab].workDataTable = construction_report_list[report_index].workDataTable;
          this.tabDataList[this.selectTab].employmentCostDataTable = construction_report_list[report_index].employmentCostDataTable;
          this.tabDataList[this.selectTab].expenseSelectBox = construction_report_list[report_index].expenseSelectBox;
          for (var data of this.expenseDivisionData) {
            if (!(data.name in construction_report_list[report_index].expenseTableData)) {
              construction_report_list[report_index].expenseTableData[data.name] = [];
            }
          }
          this.tabDataList[this.selectTab].expenseTableData = construction_report_list[report_index].expenseTableData;
          this.tabDataList[this.selectTab].totalDataTable = this.updateExpenseDivisionTotal();
        }
        this.selectTab = 'tab-1';
        this.disabledCheck();
        this.reportTotalDataTable = [
          { name: this.todayIndexName, total: 0, canExpand: true },
          { name: this.budgetTotalIndexName, total: CalcCommon.addFigure(response.data.body.construction_info.budget_price), canExpand: false },
          { name: this.achievementTotalIndexName, total: CalcCommon.addFigure(response.data.body.construction_info.achievement_price), canExpand: false },
        ];
        this.updateReportTotal();
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error",error.response.data.message);
            this.$router.push({ name: "Dashboard" })
          } else {
            this.$emit("error",error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    stringFormat(value) {
      var result = value.toString()
      while (result.match(/[０-９]/g)) {
        result = result.replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
        });
      }
      return result;
    },
    getNowYMD(){
      var dt = new Date();
      var y = dt.getFullYear();
      var m = ("00" + (dt.getMonth()+1)).slice(-2);
      var d = ("00" + dt.getDate()).slice(-2);
      var result = y + "/" + m + "/" + d;
      return result;
    },
    updateReportTotal() {
      var totalPrice = 0;
      var targetData = null;
      this.reportAggregateDataTable = [];
      for (var tabIndex in this.tabDataList) {
        for (var totalData of this.tabDataList[tabIndex].totalDataTable) {
          if (totalData.expense === this.totalIndexName) {
            continue;
          }
          totalPrice += CalcCommon.disFigure(totalData.price);
          targetData = this.reportAggregateDataTable.find((data) => {
              return (data.name === totalData.expense);
          });
          if (targetData) {
            targetData.total += CalcCommon.disFigure(totalData.price);
          } else {
            this.reportAggregateDataTable.push({
              name: totalData.expense,
              total: CalcCommon.disFigure(totalData.price)
            });
          }
        }
      }
      for (var aggregateData of this.reportAggregateDataTable) {
        aggregateData.total = CalcCommon.addFigure(aggregateData.total);
      }
      targetData = this.reportTotalDataTable.find((data) => {
          return (data.name === this.todayIndexName);
      });
      targetData.total = CalcCommon.addFigure(totalPrice);
    },
    updateExpenseDivisionTotal() {
      var totalData = [];
      var price = 0;
      var totalPrice = 0;
      for (var expenseIndex in this.tabDataList[this.selectTab].expenseTableData) {
        price = 0;
        for (var data of this.tabDataList[this.selectTab].expenseTableData[expenseIndex]) {
          price += CalcCommon.disFigure(data.price);
        }
        totalData.push({
          expense: expenseIndex,
          price: CalcCommon.addFigure(price)
        });
        totalPrice += price;
      }
      price = 0;
      for (var workData of this.tabDataList[this.selectTab].employmentCostDataTable) {
        price += CalcCommon.disFigure(workData.workPrice);
      }
      totalData.push({
        expense: this.workIndexName,
        price: CalcCommon.addFigure(price)
      });
      totalPrice += price;
      totalData.push({
        expense: this.totalIndexName,
        price: CalcCommon.addFigure(totalPrice)
      });
      return totalData;
    },
    disabledCheck () {
      this.confirmDisabled =
        (this.constructionDate == null && this.constructionDate == undefined) ||
        (this.constructionNumber == null && this.constructionNumber == undefined) ||
        (this.constructionName == null && this.constructionName == undefined)
    },
    createItem (name) {
      if (this.$refs.expense_input_form != null) {
        this.$refs.expense_input_form.resetValidation();
      }
      var aggregate = this.expenseDivisionData.find((item) => { return (item.name === name); });
      var aggregateName = name;
      if ((name in this.tabDataList[this.selectTab].expenseSelectBox) && this.tabDataList[this.selectTab].expenseSelectBox[name].length > 0) {
        this.expenseItems = this.tabDataList[this.selectTab].expenseSelectBox[name];
      } else {
        this.expenseItems = [];
      }
      this.editedItem = {
        id: "",
        supplier: null,
        supplierName: "",
        aggregate: aggregate,
        aggregateName: aggregateName,
        amount: "",
        displayUnit: "",
        expense: "",
        multiple: 0,
        no: 0,
        percentage: 1,
        price: 0,
        standard: "",
        tax: 0.1,
        taxName: "10%",
        unitPrice: 0,
        achievement: 0,
        displayAchievement: "",
        remarks: "",
        priceUpdated: this.getNowYMD()
      };
      this.price_updated = "単価";
      this.editFlg = false;
      this.expenseChangeFlg = false;
      this.expenseInputDialog = true;
    },
    editItem (item) {
      this.editedItem = item;
      this.expense = this.editedItem.expense;
      this.standard = this.editedItem.standard;
      this.amount = this.editedItem.amount;
      this.achievement = this.editedItem.achievement;
      this.displayUnit = this.editedItem.displayUnit;
      this.unitPrice = CalcCommon.disFigure(this.editedItem.unitPrice ? this.editedItem.unitPrice : 0);
      this.supplier = this.editedItem.supplier;
      this.remarks = this.editedItem.remarks;
      this.before_price = CalcCommon.disFigure(this.editedItem.unitPrice);
      this.priceUpdated = "priceUpdated" in this.editedItem ? this.editedItem.priceUpdated : this.getNowYMD();
      this.price_updated = "単価 (更新日時: " + this.priceUpdated + ")";
      this.editFlg = true;
      this.expenseEditDialog = true;
    },
    deleteItem (item) {
      this.editedItem = item;
      this.expenseDeleteDialog = true;
    },
    expenseChange() {
      if (this.expenseItem.id) {
        this.expenseId = this.expenseItem.id;
      }
      this.expense = this.expenseItem.expense;
      this.standard = this.expenseItem.standard;
      this.amount = this.expenseItem.amount;
      this.achievement = this.expenseItem.amount;
      this.displayUnit = this.expenseItem.displayUnit;
      this.unitPrice = this.expenseItem.unitPrice;
      this.before_price = this.expenseItem.unitPrice;
      this.priceUpdated = "priceUpdated" in this.expenseItem ? this.expenseItem.priceUpdated : this.getNowYMD();
      this.price_updated = "単価 (更新日時: " + this.priceUpdated + ")";
      this.expenseChangeFlg = true;
    },
    expenseInputSaveHandler () {
      var checkflg = false;
      this.editedItem.id = this.expenseId;
      this.editedItem.expense = this.expense;
      this.editedItem.standard = this.standard;
      this.editedItem.amount = this.amount;
      this.editedItem.achievement = this.achievement;
      this.editedItem.displayUnit = this.displayUnit;
      this.editedItem.unitPrice = CalcCommon.addFigure(this.unitPrice);
      this.editedItem.price = CalcCommon.addFigure(this.achievement * this.unitPrice);
      this.editedItem.supplier = this.supplier;
      this.editedItem.supplierName = this.supplier ? this.supplier.name : "";
      this.editedItem.displayAchievement = this.amount ? this.achievement + " / " + this.amount : this.achievement + " / -" ;
      this.editedItem.remarks = this.remarks;
      if (this.priceUpdated) {
        this.editedItem.priceUpdated = this.priceUpdated;
      }
      if(this.editedItem.id == ""){
        this.editedItem.id = new Date().getTime().toString() + Math.floor(Math.random() * 10).toString();
      }
      // for(var expenseitem of this.tabDataList[this.selectTab].expenseTableData[this.editedItem.aggregateName]){
      //   if(expenseitem.id == this.editedItem.id){
      //     checkflg = true;
      //   }
      // }
      if (checkflg) {
        this.expenseAlertDialog = true;
        this.expenseItem = null;
        this.expenseId = "";
        this.expense = "";
        this.standard = "";
        this.amount = "";
        this.achievement = "";
        this.displayUnit = "";
        this.unitPrice = "";
        this.supplier = null;
        this.remarks = "";
        this.before_price = null;
        this.priceUpdated = "単価";
        this.renderingKeyCount += 1;
        this.createItem(this.editedItem.aggregateName);
      }else{
        const index =  this.tabDataList[this.selectTab].expenseTableData[this.editedItem.aggregateName].indexOf(this.editedItem);
        if(index > -1) {
          this.tabDataList[this.selectTab].expenseTableData[this.editedItem.aggregateName][index] = this.editedItem
        } else {
          this.tabDataList[this.selectTab].expenseTableData[this.editedItem.aggregateName].push(this.editedItem);
        }
        this.tabDataList[this.selectTab].totalDataTable = this.updateExpenseDivisionTotal();
        this.updateReportTotal();
        this.expenseInputCancelHandler();
      }
    },
    expenseEditSaveHandler () {
      this.editedItem.id = this.expenseId;
      this.editedItem.expense = this.expense;
      this.editedItem.standard = this.standard;
      this.editedItem.amount = this.amount;
      this.editedItem.achievement = this.achievement;
      this.editedItem.displayUnit = this.displayUnit;
      this.editedItem.unitPrice = CalcCommon.addFigure(this.unitPrice);
      this.editedItem.price = CalcCommon.addFigure(this.achievement * this.unitPrice);
      this.editedItem.supplier = this.supplier;
      this.editedItem.supplierName = this.supplier ? this.supplier.name : "";
      this.editedItem.displayAchievement = this.amount ? this.achievement + " / " + this.amount : this.achievement + " / -" ;
      this.editedItem.remarks = this.remarks;
      if (this.priceUpdated) {
        this.editedItem.priceUpdated = this.priceUpdated;
      }
      const index =  this.tabDataList[this.selectTab].expenseTableData[this.editedItem.aggregateName].indexOf(this.editedItem);
      if(index > -1) {
        this.tabDataList[this.selectTab].expenseTableData[this.editedItem.aggregateName][index] = this.editedItem
      } else {
        this.tabDataList[this.selectTab].expenseTableData[this.editedItem.aggregateName].push(this.editedItem);
      }
      this.tabDataList[this.selectTab].totalDataTable = this.updateExpenseDivisionTotal();
      this.updateReportTotal();
      this.expenseEditCancelHandler();
    },
    expenseInputCancelHandler () {
      this.expenseItem = null;
      this.expenseId = "";
      this.expense = "";
      this.standard = "";
      this.amount = "";
      this.achievement = "";
      this.displayUnit = "";
      this.unitPrice = "";
      this.supplier = null;
      this.remarks = "";
      this.before_price = null;
      this.priceUpdated = "単価";
      this.expenseInputDialog = false;
      this.renderingKeyCount += 1;
      this.expenseChangeFlg = false;
    },
    expenseEditCancelHandler () {
      this.expenseItem = null;
      this.expenseId = "";
      this.expense = "";
      this.standard = "";
      this.amount = "";
      this.achievement = "";
      this.displayUnit = "";
      this.unitPrice = "";
      this.supplier = null;
      this.remarks = "";
      this.before_price = null;
      this.priceUpdated = "単価";
      this.expenseEditDialog = false;
      this.renderingKeyCount += 1;
    },
    supplierStoreDialogCancelHandler() {
      this.supplierStoreDialog = false;
      this.supplierName = "";
      this.supplierRemarks = "";
    },
    supplierStoreDialogHandler() {
      this.supplierStoreDialog = true;
      if (this.$refs.suppliers_form) {
        this.$refs.suppliers_form.resetValidation();
      }
    },
    supplierStore() {
      if (this.$refs.suppliers_form.validate()) {
        this.isLoading();
        const params = {
          name: this.supplierName,
          remarks: this.supplierRemarks,
        };
        const promiseStore = this.suppliersApi.store(params);
        promiseStore.then((response) => {
            this.$emit('success', response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.supplierStoreDialog = false;
          const promiseList = this.suppliersApi.list();
          promiseList.then((response) => {
            this.suppliers = [];
            for (var sup of response.data.body.suppliers_list) {
              this.suppliers.push({
                name: sup.name,
                value: sup.id
              });
            }
          }).catch(error => {
            useAppInsights().trackException({exception: error});
            if (error.response) {
              if (error.response.data.status == statusList.status.authError) {
                this.$emit('logoutConform');
              } else if (error.response.data.status == statusList.status.entityError) {
                this.$emit("error",error.response.data.message);
                this.$router.push({ name: "Dashboard" })
              } else {
                this.$emit("error",error.response.data.message);
              }
            } else {
              this.$emit("error","サーバーエラーが発生しました。");
            }
          }).finally(() => {
            this.supplierName = "";
            this.supplierRemarks = "";
            this.isLoading();
          });
        });
      }
    },
    expenseDeleteHandler () {
      const index =  this.tabDataList[this.selectTab].expenseTableData[this.editedItem.aggregateName].indexOf(this.editedItem);
      this.tabDataList[this.selectTab].expenseTableData[this.editedItem.aggregateName].splice(index,1)
      this.tabDataList[this.selectTab].totalDataTable = this.updateExpenseDivisionTotal();
      this.updateReportTotal();
      this.expenseDeleteDialog = false;
      this.renderingKeyCount += 1;
    },
    submit () {
      this.isLoading();
      var params = [];
      for (var index in this.tabDataList) {
        for (var employmentData of this.tabDataList[index].employmentCostDataTable) {
          employmentData.unitPrice = CalcCommon.disFigure(employmentData.unitPrice);
          employmentData.workPrice = CalcCommon.disFigure(employmentData.workPrice);
        }
        for (var expanseIndex in this.tabDataList[index].expenseTableData) {
          for (var expanseData of this.tabDataList[index].expenseTableData[expanseIndex]) {
            expanseData.unitPrice = CalcCommon.disFigure(expanseData.unitPrice);
            expanseData.price = CalcCommon.disFigure(expanseData.price);
          }
        }
        for (var totalIndex in this.tabDataList[index].totalDataTable) {
          this.tabDataList[index].totalDataTable[totalIndex].price = CalcCommon.disFigure(this.tabDataList[index].totalDataTable[totalIndex].price);
        }
        params.push({
          isReport: true,
          construction_id: this.constructionID,
          worker_date: this.constructionDate,
          report: JSON.stringify(this.tabDataList[index])
        });
      }
      var today_total_price = CalcCommon.disFigure(this.reportTotalDataTable.find((data) => {
        return (data.name === this.todayIndexName);
      }).total);
      var achievement_price = CalcCommon.disFigure(this.reportTotalDataTable.find((data) => {
        return (data.name === this.achievementTotalIndexName);
      }).total) + today_total_price;
      params.push({
        isReport: false,
        construction_id: this.constructionID,
        achievement_price: String(achievement_price)
      });
      const promise = this.constructionDailyReportApi.store({ params: params });
      promise.then((response) => {
        this.$emit('success', response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if(error.response){
          if(error.response.data.status == statusList.status.authError){
            this.$emit('logoutConform');
          } else {
            this.$emit("error",error.response.data.message);
          }
        }else{
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
        this.$router.push({ name: 'ConstructionDailyReport', params: { number: this.constructionNumber } });
      });
    },

    // ---------------------------------------------
    // イベント処理「作業内容参照」ボタン押下
    // ---------------------------------------------
    showWorkerContentReferenceDialog(item) {
      this.workItem = item;
      this.workerContentReferenceDialogDrawer = true;
    },
  }
}
</script>
